<template>
    <v-container>
        <v-layout
                wrap
        >
            <Title>Services</Title>
            <ServiceList :services="servicesColumn1"/>
            <ServiceList :services="servicesColumn2"/>
        </v-layout>
    </v-container>
</template>

<script>
    import ServiceList from './ServiceList'
    import Title from './Title'
    import { sync } from 'vuex-pathify';
    const axios = require('axios');

    export default {
        name: 'Services',
        components: { ServiceList, Title },
        data() {
            return {}
        },
        computed: {
            ...sync(['servicesColumn1', 'servicesColumn2', 'serviceUrl',
                'serviceEndpoints.GET_SERVICE_ROW1', 'serviceEndpoints.GET_SERVICE_ROW2'])
        },
        mounted: function () {
            let me = this;
            if ((this.servicesColumn1 === undefined) || (this.servicesColumn1 === null)  || (this.servicesColumn1.length === 0)) {
                axios.get(this.serviceUrl + this.GET_SERVICE_ROW1)
                    .then(function (response) {
                        me.servicesColumn1 = response.data.payload;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }

            if ((this.servicesColumn2 === undefined) || (this.servicesColumn2 === null)  || (this.servicesColumn2.length === 0)) {
                axios.get(this.serviceUrl + this.GET_SERVICE_ROW2)
                    .then(function (response) {
                        me.servicesColumn2 = response.data.payload;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style>
</style>
